import { Trans, useTranslation } from 'react-i18next'
import { Button, Heading, LinkButton } from '@repo/ui'
import { DoneIcon32 } from '@repo/ui/icons'
import { Dialog, DialogContent, useDialog } from '@/components/common/dialog'
import PrivacyPolicy from '@/features/legal/PrivacyPolicy'
import { useSettingsStore } from '@/store/useSettingsStore'
import { useNavigate } from 'react-router-dom'

export default function AcceptPrivacyPolicy() {
  const navigate = useNavigate()
  const { t } = useTranslation(['acceptPrivacyPolicy', 'common'])
  const [policyDialogState, openPolicyDialog, closePolicyDialog] = useDialog()
  const testIdInit = `accept-privacy-policy-page`

  const { setPrivacyPolicyAccepted } = useSettingsStore()

  const onClick = () => {
    setPrivacyPolicyAccepted(true)
    navigate('/')
  }

  return (
    <div className="text-left">
      <Heading tag="h1">{t('acceptPrivacyPolicy:title')}</Heading>
      <p data-testid={`${testIdInit}-text`}>
        <Trans
          t={t}
          i18nKey="acceptPrivacyPolicy:privacy_policy_link"
          components={{
            overlay: (
              <LinkButton
                onClick={() => openPolicyDialog()}
                data-testid={`${testIdInit}-link`}
              />
            )
          }}
        />
      </p>
      <Dialog
        state={policyDialogState}
        title={t('common:privacy.title')}
        onClose={closePolicyDialog}
        className="max-w-3xl"
        data-testid={`${testIdInit}-dialog`}
      >
        <DialogContent data-testid={`${testIdInit}-dialog-content`}>
          <PrivacyPolicy data-testid={`${testIdInit}-dialog-content-text`} />
        </DialogContent>
      </Dialog>

      <div className="flex flex-col gap-1 mt-2.5">
        <Button
          type="button"
          data-testid={`${testIdInit}-button`}
          onClick={onClick}
        >
          <DoneIcon32
            className="shrink-0"
            data-testid={`${testIdInit}-button-icon`}
          />
          <span className="pl-0.5" data-testid={`${testIdInit}-button-text`}>
            {t('acceptPrivacyPolicy:apply_button')}
          </span>
        </Button>
      </div>
    </div>
  )
}
